import React, { useRef, useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom';
import { ReactComponent as AppleIcon } from 'assets/svg/apple-white.svg';
import { ReactComponent as VkIcon } from 'assets/svg/VK.svg';
import { ReactComponent as InstagramIcon } from 'assets/svg/instagram.svg';
import { ReactComponent as RutubeIcon } from 'assets/svg/rutube.svg';
import { ReactComponent as YoutubeIcon } from 'assets/svg/youtube.svg';
// import { ReactComponent as SpotifyIcon } from 'assets/svg/spotify.svg';
// import { ReactComponent as TiktokIcon } from 'assets/svg/tiktok.svg';
import ShopModalContent from './ShopModalContent.js'
import Modal from './Modal.js'
import ModalAuth from './ModalAuth.js'
import AccountSidebar from './AccountSidebar.js';

import VideoUploadForm from './VideoUploadForm'


export default function Header({ setIsOpenModal, setCurrentContentModal }) {
  let location = useLocation();
  const [pathname, _setPathname] = useState(location.pathname)

  const [isAuthBtn, setIsAuthBtn] = useState(false)

  const [openAuthModal, setOpenAuthModal] = useState(false)

  const [isAuth, setIsAuth] = useState(false)

  const [user, setUser] = useState({})

  const [dropDown, setDropDown] = useState(false)

  const [loadVideoModal, setLoadVideoModal] = useState(false)


  useEffect(() => {
    const token = JSON.parse(localStorage.getItem("token"))
    if (token) {
      setUser(token.userObj)
      setIsAuth(!!token)
    }

  }, [])


  const pathnameRef = useRef(pathname);

  const setPathname = data => {
    pathnameRef.current = data;
    _setPathname(data);
  };

  const checkHeaderScroll = function () {
    const headerNameEl = document.querySelector('.header__name');
    const headerEl = document.querySelector('.header');
    headerNameEl.classList.remove('header__name--hide');
    headerEl.classList.remove('header--fading')
    if (pathnameRef.current === '/') {
      if (window.scrollY < 220) {
        headerNameEl.classList.add('header__name--hide');
        headerEl.classList.add('header--fading')
      }
    }
  }

  useEffect(() => {
    setPathname(location.pathname)
    checkHeaderScroll();
    window.addEventListener('scroll', checkHeaderScroll);
    if (location.pathname === "/" || location.pathname.split("/")[1] === "artist" || location.pathname.split("/")[1] === "music" || location.pathname.split("/")[1] === "concerts") {
      setIsAuthBtn(true)
    } else {
      setIsAuthBtn(false)

    }

  }, [location.pathname])

  const handleOpenModalShop = (e) => {
    setIsOpenModal(true)
    e.preventDefault()
    setCurrentContentModal(<ShopModalContent onClose={() => setIsOpenModal(false)} />)
  }


  return (
    <div className={`header ${(pathnameRef.current === '/') ? 'header--fading' : ''}`}>
      <div className="header__left">
        {/* Menu */}
        <div className="header__menu">

          <Link to="/concerts">
            <div> Концерты </div>
          </Link>
          <Link to="/shop" onClick={handleOpenModalShop}>
            <div> Магазин </div>
          </Link>
          <Link to="/music">
            <div> Музыка </div>
          </Link>
        </div>
      </div>

      {/* Rishat Tukhvatullin */}
      <Link className="header__name" to="/" style={{ display: isAuthBtn ? "block" : "none" }} >
        Ришат Тухватуллин
      </Link>

      {/* social links */}
      <div>
        {/* 
        <a className="header__link header__link-tiktok" rel="noopener noreferrer" href="https://vm.tiktok.com/ZSxbno9F/" target="_blank">
          <TiktokIcon />
        </a>
        <a className="header__link header__link-spotify" rel="noopener noreferrer" href="https://open.spotify.com/artist/10MgajZ7vRn9LVChqjykmj" target="_blank">
          <SpotifyIcon />
        </a>
        <a className="header__link header__link-apple" rel="noopener noreferrer" href="https://music.apple.com/ru/artist/%D1%80%D0%B8%D1%88%D0%B0%D1%82-%D1%82%D1%83%D1%85%D0%B2%D0%B0%D1%82%D1%83%D0%BB%D0%BB%D0%B8%D0%BD/1529902345" target="_blank">
          <AppleIcon />
        </a>
        */}
        {isAuthBtn ?
          <div className="header__links">
            <a className="header__link header__link-vk" rel="noopener noreferrer" href="https://vk.com/rishat_tukhvatullin_rt" target="_blank">
              <VkIcon />
            </a>
            <a className="header__link header__link-rutube" rel="noopener noreferrer" href="https://rutube.ru/channel/46152335/" target="_blank">
              <RutubeIcon />
            </a>
            <a className="header__link header__link-youtube" rel="noopener noreferrer" href="https://www.youtube.com/channel/UC09mFevxJZCYyTve3yFffmQ" target="_blank">
              <YoutubeIcon />
            </a>
            <a className="header__link header__link-instagram" rel="noopener noreferrer" href="https://www.instagram.com/rishat_thv/" target="_blank">
              <InstagramIcon />
            </a>
          </div> :
          <>
            {isAuth ? <div className="header-dropdown" onMouseEnter={() => setDropDown(true)}
              onMouseLeave={() => setDropDown(false)} onClick={() => setDropDown(prevState => !prevState)}> <button className="header-btn header__btn-ui" >{user.lastName[0].toUpperCase() + user.lastName.slice(1).toLowerCase()} {user.firstName.slice(0, 1).toUpperCase()}.</button> {dropDown && <AccountSidebar loadVideoModal={loadVideoModal} setLoadVideoModal={setLoadVideoModal} setIsAuth={setIsAuth} setUser={setUser} user={user} />} </div> : <button className="header-btn header__btn-ui" onClick={() => setOpenAuthModal(true)}>АВТОРИЗАЦИЯ</button>}
          </>
        }
      </div>
      {
        openAuthModal && (
          <Modal onClose={() => setOpenAuthModal(false)}>
            <ModalAuth openAuthModal={openAuthModal} setOpenAuthModal={setOpenAuthModal} />
          </Modal>
        )
      }
      {
        loadVideoModal && (
          <Modal onClose={() => setLoadVideoModal(false)}>
            <VideoUploadForm />
          </Modal>
        )
      }
    </div >
  )
}
